module.exports = __webpack_public_path__ + "static/media/Buildings.68151077.svg";